import React from "react";

function CommonChip({ label, from }) {
  let result = "";
  if (from === "location") result = label?.city + ", " + label?.state;
  if (from === "degree") result = label?.name;
  if (from === "years") result = label;
  if (from === "skills") result = label?.skill_name;
  if (from === "work from home") result = label;

  return (
    <div className=" h-[30px] w-fit  flex items-center px-2  border border-[#2563EB] bg-[#E6EEFF] text-[#2563EB] text-sm  rounded-md ">
      <p>{result}</p>
    </div>
  );
}

export default CommonChip;
